module.exports = __webpack_public_path__ + "static/media/Menu-close-white.2bb36693.svg";